import store from '@/store'

import async from 'async'

import restResource from '@/technical/restResource'

import http from 'axios'

import Vue from 'vue'

export default {
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Блок управленческой информации по работе serverData. подключен ли сервер, какие данные загружены и тд
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // isLoaded: false, // true когда все данные с сервера подгружены успешно - ПОКА ЭТО РАБОТАЕТ КАК ЕДИНЫЙ ПАРАМЕТЕР У commonData.isLoaded

  eventsBus: new Vue(),

  // status: 'not connected',

  loadingDataStatus: {
    types: {INITIAL: 0, LOADING: 1, LOADED: 2, ERROR: 3},

    mainCommonData: 0,
    appSettings: 0, // true когда все данные подгружены успешно. необходим, потому что по пустому полю appSettings, tasks и тд не понятно это еще не скачено или уже пришел пустой ответ
    tasks: 0
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mainCommonDataLoadedSetTrue: function () {
    var thisRef = this
    thisRef.loadingDataStatus.mainCommonData = thisRef.loadingDataStatus.types.LOADED
    setTimeout(function () {
      thisRef.eventsBus.$emit('mainCommonDataLoaded')
    }, 1)
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  appSettings: {},
  appSettingsReload: function (cb) {
    this.appSettings = {}
    this.loadingDataStatus.appSettings = this.loadingDataStatus.types.LOADING

    var thisRef = this

    async.parallel({
      /* tasksModuleSettings: function (asyncCallback) {
        http.get(store.getters.appSettings.server.host + store.getters.appSettings.server.settingsResource + store.getters.appSettings.server.tasksModuleSettingsCriteria)
        .then(function (response) {
          if (response.data[0] != null) {
            // thisRef.akcii = JSON.parse(response.data)[0].value
            thisRef.appSettings.tasks = response.data[0].value
          }
          asyncCallback()
        })
        .catch() // сам вызывает asyncCallback
      },

      finixModuleSettings: function (asyncCallback) {
        http.get(store.getters.appSettings.server.host + store.getters.appSettings.server.settingsResource + store.getters.appSettings.server.finixModuleSettingsCriteria)
        .then(function (response) {
          if (response.data[0] != null) {
            // thisRef.akcii = JSON.parse(response.data)[0].value
            thisRef.appSettings.finix = response.data[0].value

            thisRef.appSettings.finix.finixOrdersStatusesMap = {}
            for (var [key] of Object.entries(thisRef.appSettings.finix.finixOrdersStatuses)) {
              thisRef.appSettings.finix.finixOrdersStatusesMap[thisRef.appSettings.finix.finixOrdersStatuses[key].id] = thisRef.appSettings.finix.finixOrdersStatuses[key].name
            }
          }
          asyncCallback()
        })
        .catch() // сам вызывает asyncCallback
      },
      */
      mainMenuPermissionsByUserGroups: function (asyncCallback) {
        http.get(store.getters.appSettings.server.host + store.getters.appSettings.server.settingsResource + store.getters.appSettings.server.mainMenuPermissionsByUserGroupsCriteria)
        .then(function (response) {
          if (response.data[0] != null) {
            // thisRef.akcii = JSON.parse(response.data)[0].value
            thisRef.appSettings.mainMenuPermissionsByUserGroups = response.data[0].value
          }
          asyncCallback() // сам вызывает asyncCallback
        })
        .catch()
      }

    }, function (error) {
      // console.log('serverData.appSettingsReload')
      // console.log(thisRef.appSettings)
      // console.log(error)
      if (!error) {
        thisRef.loadingDataStatus.appSettings = thisRef.loadingDataStatus.types.LOADED
        setTimeout(function () {
          thisRef.eventsBus.$emit('appSettingsChanged', {method: 'read', initiator: 'serverData.appSettingsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        }, 1)
      } else thisRef.loadingDataStatus.appSettings = thisRef.loadingDataStatus.types.ERROR

      cb(error)
    })
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  tasks: [],
  tasksGetOneById: function (id) {
    for (var i = 0; i < this.tasks.length; i++) {
      if (this.tasks[i].val.id === id) {
        return this.tasks[i]
      }
    }
    return null
  },
  tasksOnDestroyDelegates: [],
  tasksOnDestroy: function (deletedRecord, cb) {
    async.each(this.tasksOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  tasksReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.tasks.splice(0, this.tasks.length)
    this.loadingDataStatus.tasks = this.loadingDataStatus.types.LOADING

    var thisRef = this
    // var systemDocs = []
    var taskResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskResource)
    taskResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.tasks.splice(0, thisRef.tasks.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneTaskResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskResource)
        oneTaskResource.val = response.data[itemIndx]
        oneTaskResource.CodeAsInt = parseInt(oneTaskResource.val.Code)
        thisRef.tasks.push(oneTaskResource)
      }
      thisRef.loadingDataStatus.tasks = thisRef.loadingDataStatus.types.LOADED
      setTimeout(function () {
        thisRef.eventsBus.$emit('tasksChanged', {method: 'read', initiator: 'serverData.tasksReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(function (err) {
      thisRef.loadingDataStatus.tasks = thisRef.loadingDataStatus.types.ERROR
      cb(err)
    })
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  partners: [],
  partnersGetOneById: function (id) {
    for (var i = 0; i < this.partners.length; i++) {
      if (this.partners[i].val.id === id) {
        return this.partners[i]
      }
    }
    return null
  },
  partnersOnDestroyDelegates: [],
  partnersOnDestroy: function (deletedRecord, cb) {
    async.each(this.partnersOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  partnersReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.partners.splice(0, this.partners.length)

    var thisRef = this
    // var systemDocs = []
    var partnerResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.partnerResource)
    partnerResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.partners.splice(0, thisRef.partners.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var onePartnerResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.partnerResource)
        onePartnerResource.val = response.data[itemIndx]
        onePartnerResource.CodeAsInt = parseInt(onePartnerResource.val.Code)
        thisRef.partners.push(onePartnerResource)
      }
      setTimeout(function () {
        thisRef.eventsBus.$emit('partnersChanged', {method: 'read', initiator: 'serverData.partnersReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(cb)
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  finixBanks: [],
  finixBanksGetOneById: function (id) {
    for (var i = 0; i < this.finixBanks.length; i++) {
      if (this.finixBanks[i].val.id === id) {
        return this.finixBanks[i]
      }
    }
    return null
  },
  finixBanksOnDestroyDelegates: [],
  finixBanksOnDestroy: function (deletedRecord, cb) {
    async.each(this.finixBanksOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  finixBanksReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.finixBanks.splice(0, this.finixBanks.length)

    var thisRef = this
    // var systemDocs = []
    var finixBankResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.finixBankResource)
    finixBankResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.finixBanks.splice(0, thisRef.finixBanks.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneFinixBankResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.finixBankResource)
        oneFinixBankResource.val = response.data[itemIndx]
        oneFinixBankResource.CodeAsInt = parseInt(oneFinixBankResource.val.Code)
        thisRef.finixBanks.push(oneFinixBankResource)
      }
      setTimeout(function () {
        thisRef.eventsBus.$emit('finixBanksChanged', {method: 'read', initiator: 'serverData.finixBanksReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(cb)
  }

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}



// WEBPACK FOOTER //
// ./src/store/serverData.js